import script from "./Proton.vue?vue&type=script&setup=true&lang=js"
export * from "./Proton.vue?vue&type=script&setup=true&lang=js"

import "./Proton.vue?vue&type=style&index=0&id=4940f10c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4940f10c"]])

export default __exports__